import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import dayjs from 'dayjs';
import { I_TourIDItem } from '@Redux/detail/Group/interfaces';
import {
    setCurrentTourID,
    setGroupAllCalendar,
    setSchedulesActive,
} from '@Redux/detail/Group/actions';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';

function SchedulesList() {
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { Schedules, scheduleActive } = useSelector((state: RootState) => state.groupReducer);
    const dispatch = useDispatch();
    const initTourID = JSON.parse(travelinfo!).GroupInfo.TourID;

    function clickScheduleType(TourID: string, idx: number) {
        const isAll = idx === 0; // 行程選擇全部
        dispatch(setCurrentTourID(isAll ? '' : TourID));
        dispatch(setSchedulesActive(idx));
    }

    return Schedules ? (
        <div className={styles.contentBlock}>
            <div
                className={cN(styles.item, scheduleActive === 0 && styles['active'])}
                onClick={() => clickScheduleType(initTourID, 0)}
            >
                全部
            </div>
            {Schedules!.TourIDList.map((item: I_TourIDItem, idx: number) => (
                <div
                    className={cN(styles.item, idx + 1 === scheduleActive && styles['active'])}
                    key={idx}
                    onClick={() => clickScheduleType(item.TourID, idx + 1)}
                    data-tourid={item.TourID}
                >
                    行程{idx + 1}
                </div>
            ))}
        </div>
    ) : null;
}

export default SchedulesList;
